<template>
  <div class="fetch_content_spinner_container levels-loading">
    <v-overlay v-model="overlay" scroll-strategy="none" persistent></v-overlay>
    <div class="levels-logo">
      <svg width="100%" height="100%" viewBox="0 0 325 260">
        <path id="bottom" d="M307.644,67.348l-118.795,163.833l-59.916,-100.088l-95.597,118.19l94.927,-92.274l60.51,100.991l131.716,-181.816l-12.845,-8.836Z" />
        <path id="top" d="M309.655,2l-120.806,165.437l-59.916,-100.089l-126.433,184.701l125.763,-158.785l60.51,100.991l133.727,-183.419l-12.845,-8.836Z" />
      </svg>
    </div>
    <h1 class="fetch_content_spinner_text">{{ sportTitle }}levels is Loading...</h1>
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import { sportTitle } from '@/services/admin_actions/apiUtils';

const overlay = ref(true); // Controls the visibility of the overlay
</script>

<style lang="scss">
$animation-timing: 4s;
// Center the spinner and loading text
.fetch_content_spinner_container {
  height: calc(100vh - 64px - 130px);
  display: flex;
  flex-direction: column;
  align-content: center;
  align-items: center;
  justify-content: center;
  gap: 15px;
}

// Increase spinner and loader text Height on Mobile
@media (max-width: 767px) {
  .fetch_content_spinner_container {
    height: calc(100vh - 64px - 46px);
  }
}

.fetch_content_spinner_text {
  color: rgba(var(--v-theme-primary));
  font-size: 22px;
  font-weight: 500;
  font-style: italic;
  z-index: 10000;
}
.levels-logo {
  display: flex;
  position: relative;
  width: 200px;
  margin: 0 auto;
  padding: 16px;
  animation: opacity $animation-timing linear infinite;
  z-index: 10000;

  svg {
    fill-rule: evenodd;
    clip-rule: evenodd;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-miterlimit: 1.5;
  }

  #top,
  #bottom {
    stroke: rgba(var(--v-theme-secondary));
    stroke-width: 3px;
    fill: rgba(var(--v-theme-secondary));
    fill-opacity: 0;
    stroke-dasharray: 1200;
    animation: dash $animation-timing linear infinite;
  }

  #bottom {
    stroke-dasharray: 1050;
    animation: dash-2 $animation-timing linear infinite;
  }
}
@keyframes dash {
  0%,
  1%,
  99%,
  100% {
    fill-opacity: 0;
    stroke-dashoffset: 1200;
  }
  50% {
    fill-opacity: 0;
    stroke-dashoffset: 0;
  }
  70% {
    fill-opacity: 1;
    stroke-dashoffset: 0;
  }
  98% {
    fill-opacity: 1;
    stroke-dashoffset: 0;
  }
}

@keyframes dash-2 {
  0%,
  1%,
  99%,
  100% {
    fill-opacity: 0;
    stroke-dashoffset: 1050;
  }
  50% {
    fill-opacity: 0;
    stroke-dashoffset: 0;
  }
  70% {
    fill-opacity: 1;
    stroke-dashoffset: 0;
  }
  98% {
    fill-opacity: 1;
    stroke-dashoffset: 0;
  }
}

@keyframes opacity {
  1% {
    opacity: 1;
  }
  85% {
    opacity: 1;
  }
  0%,
  97%,
  100% {
    opacity: 0;
  }
}
</style>
